import store from 'dashboard/store';

/**
 * Mask phone-number-like sequences inside a contact name for non-admin agents.
 * WhatsApp contact names are frequently the raw phone number, so a simple
 * field-level guard is not enough. Administrators always see the full name.
 *
 * @param {string} name - the raw contact name
 * @returns {string} - the (possibly) masked name
 */
export function maskContactName(name) {
  if (!name) return name;
  try {
    const role = store.getters.getCurrentRole;
    if (role === 'administrator') return name;
  } catch (e) {
    // if store not ready, fail safe to masking
  }
  // Remove +country, spaces, dashes, parentheses sequences of >= 5 digits.
  // Examples handled: '+90 (53) 8608-4588 - Omar' -> '••• - Omar'
  let masked = name.replace(/\+?[\d][\d\s().-]{4,}\d/g, '•••');
  // Collapse leftover separators like '••• - Omar' / '•••  Omar'
  masked = masked.replace(/^[\s•-]*•••[\s-]*/, '••• ').trim();
  if (masked === '' ) masked = '•••';
  return masked;
}

export default maskContactName;
